import { Grid2 as Grid } from "@mui/material";
import { ConditionalGridProps } from "./types";

export function ConditionalGrid({ isVisible, children, ...rest }: ConditionalGridProps) {
  return (
    <Grid
      size={{ xs: 12}}
      py={2}
      style={{
        visibility: isVisible ? 'visible' : 'hidden',
        position: isVisible ? 'relative' : 'absolute',
        height: isVisible ? 'auto' : 0,
        overflow: 'hidden',
      }}
      {...rest}
    >
      {children}
    </Grid>
  );
}
